export default __webpack_public_path__ + "static/media/blue_1.png";